module.exports = __webpack_public_path__ + "img/noplan.c5925ea8.png";